import React, { useState } from 'react';
import { Button } from 'antd';

import AuthInfo from '../../components/AuthInfo/AuthInfo';
import AuthForm from '../../components/AuthForm/AuthForm';
import { toastNotify } from '../../utils/toastNotify';
import { sendVerificationLink } from '../../services/authApi/forgotPasswordApi';

const ActivateForgotPassword = () => {
  const [countDown, setCountDown] = useState(0);
  const [isShowResend, setShowResend] = useState(false);

  const handleResendEmail = async () => {
    let formData = {
        email: localStorage.getItem("email"),
        phoneNumber: null,
        credentialType: "password"
      }
      try {
        const userData = await sendVerificationLink(formData);
        if (!userData.isError) {
          localStorage.setItem("email", localStorage.getItem("email"));
          toastNotify("success", userData.message);
          timerCounter();
        } else {
          toastNotify("error", userData?.message);
        }
      } catch (error) {
        const { response } = error;
        toastNotify("error", response?.data?.message);
      }
  };
  const timerCounter = (timerValue = 30) => {
    setShowResend(true);
    let timeleft = timerValue;
    const downloadTimer = setInterval(() => {
      if(timeleft <= 0){
        clearInterval(downloadTimer);
        setCountDown(0);
        setShowResend(false);
      } else {
        if(timeleft < 10) {
          timeleft = 0 + '' + timeleft;
        }
        setCountDown(timeleft);
      }
      timeleft -= 1;
    }, 1000);
  }


  return (
    <div className='auth auth--no-info-mobile auth--activation'>
      <AuthInfo title={<>Activate your account</>} />
      <AuthForm
        title={<>Verify your email</>}
        description={
          <>
            <p>
              Check your inbox to activate your account. We sent an email to <br />{' '}
              <span className='fw-600'>{localStorage.getItem("email")}</span>
            </p>
            <p>
              The link will expire in 10 minutes. Didn’t receive an email?{' '}
              <Button 
                className='p-0 mr-8 fw-600 underline text-terracotta h-auto' 
                type='text' 
                onClick={() => handleResendEmail()}
                disabled={isShowResend}
              >
                Resend email
              </Button>
              {countDown > 0 && <span>{countDown}</span> }
            </p>
          </>
        }
      ></AuthForm>
    </div>
  );
};

export default ActivateForgotPassword;
